import { useProjectJobRoleFindManyQuery } from 'generated/graphql';
import { TSelectFormFieldValue } from 'interfaces/forms/form';
import { useState } from 'react';
import ExistingReport from 'views/User/UserDetails/UserMainResets/UserReset/StageReset/ReportsManagement/ExistingReport';
import NewReport from './NewReport';
import styles from './ReportsManagement.module.scss';

const ReportsManagement = ({
  companyId,
  projectId,
  stageId,
  isDisabled,
  stageCandidateId,
}: {
  companyId: number;
  projectId: number;
  stageId: number;
  isDisabled: boolean;
  stageCandidateId: number;
}) => {
  const [selectedJobRoleId, setSelectedJobRoleId] =
    useState<TSelectFormFieldValue>('');

  const { data: projectJobRoles } = useProjectJobRoleFindManyQuery({
    variables: {
      id: projectId,
    },
    onCompleted: data => {
      if (data?.ProjectJobRoleFindMany) {
        setSelectedJobRoleId(data?.ProjectJobRoleFindMany[0]?.id);
      }
    },
  });

  const isProjectMultimatch =
    (projectJobRoles?.ProjectJobRoleFindMany.length ?? 0) > 1;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Reports management</h3>
      <div className={styles.content}>
        <NewReport
          stageCandidateId={stageCandidateId}
          isDisabled={isDisabled}
          stageId={stageId}
          projectId={projectId}
          companyId={companyId}
          projectJobRoles={projectJobRoles}
          isProjectMultimatch={isProjectMultimatch}
          selectedJobRoleId={selectedJobRoleId}
          setSelectedJobRoleId={setSelectedJobRoleId}
        />
        <div className={styles.separator}></div>
        <ExistingReport
          projectJobRoles={projectJobRoles}
          stageCandidateId={stageCandidateId}
          isMultimatch={isProjectMultimatch}
          isDisabled={isDisabled}
          selectedJobRoleId={selectedJobRoleId}
          setSelectedJobRoleId={setSelectedJobRoleId}
        />
      </div>
    </div>
  );
};

export default ReportsManagement;
